import { ProviderName } from "@lib/components/MiniComponents/Others";
import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { useTypedSelector, useTypedDispatch } from "@lib/redux";
import { setSelectedPaymentProvider } from "@lib/redux/slices/cache";
import { FormattedMessage } from "react-intl";
import { apiGetProviders } from "@lib/api/provider";

type Props = {
  style?: React.CSSProperties;
};

export default function SelectedPaymentProviderSelectBox({ style }: Props) {
  const dispatch = useTypedDispatch();
  const { selectedPaymentProvider } = useTypedSelector((state) => state.cache);

  const { data } = useQuery({
    queryKey: ["payment-provider-dropdown"],
    queryFn: () =>
      apiGetProviders({
        sort: "name,ASC",
        limit: 100,
      }),
  });
  const apiData = data?.data?.data;

  return (
    <Select
      value={selectedPaymentProvider?.id || "all"}
      onChange={(value) => {
        dispatch(
          setSelectedPaymentProvider(
            apiData?.find((item) => item.id === value),
          ),
        );
      }}
      showSearch
      style={{ width: "100%", ...style }}
      filterOption={(input, option) =>
        option?.text?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      options={[
        {
          label: <FormattedMessage id="common.all" />,
          text: "All",
          value: "all",
        },
        ...(apiData?.map((item) => ({
          label: <ProviderName provider={item} titleMaxLength={20} />,
          text: item.name,
          value: item.id,
        })) || []),
      ]}
    />
  );
}
